{
  "page": {
    "title": "Bảng điều khiển",
    "mobileNotice": {
      "title": "Hãy dùng máy tính",
      "body": "Bảng điều khiển admin được tối ưu cho màn hình từ 768px trở lên. Mở Printway trên máy tính hoặc xoay ngang máy tính bảng để xem các chỉ số vận hành."
    },
    "kpiError": "Không tải được KPI — đang thử lại.",
    "vendorActivityAria": "Hiệu suất vendor + hoạt động"
  },
  "kpi": {
    "labels": {
      "total_merchants": "Tổng Merchant",
      "active_orders": "Đơn đang xử lý",
      "gross_revenue": "Doanh thu gộp",
      "cogs": "Giá vốn (COGS)",
      "gross_margin": "Lợi nhuận gộp",
      "avg_vendor_rating": "Đánh giá vendor TB",
      "pending_topups": "Nạp tiền chờ duyệt",
      "open_support_tickets": "Hỗ trợ đang mở",
      "sync_errors_24h": "Lỗi đồng bộ 24h",
      "order_warnings": "Cảnh báo đơn hàng",
      "new_blueprints": "Blueprint mới",
      "outstanding_invoices": "Hóa đơn chưa thanh toán"
    },
    "newBlueprintsBreakdown": "Chờ duyệt {{pending}} · Từ chối {{rejected}} · Đã duyệt {{approved}} · Tỉ lệ {{rate}}",
    "gridAria": "Các KPI của dashboard"
  },
  "quickActions": {
    "srHeading": "Hành động nhanh",
    "pendingAria": "{{count}} đang chờ",
    "reviewKyc": "Duyệt KYC",
    "reviewTopups": "Duyệt nạp tiền",
    "assignOrders": "Phân công đơn",
    "supportInbox": "Hộp thư hỗ trợ",
    "syncErrors": "Lỗi đồng bộ",
    "reviewBlueprints": "Duyệt blueprint"
  },
  "alerts": {
    "srHeading": "Cảnh báo vận hành",
    "unavailable": "Không tải được cảnh báo — đang thử lại.",
    "detail": "Chi tiết",
    "viewAll": "Xem tất cả ({{total}})",
    "categoryAria": "Nhóm {{category}}",
    "categories": {
      "sla": "SLA",
      "capacity": "Năng lực",
      "sync": "Đồng bộ"
    }
  },
  "activity": {
    "heading": "Hoạt động gần đây",
    "refreshing": "Đang làm mới…",
    "loadError": "Không tải được dòng hoạt động.",
    "empty": "Chưa có hoạt động nào.",
    "loadOlderError": "Không tải được hoạt động cũ hơn.",
    "loading": "Đang tải…",
    "loadOlder": "Tải cũ hơn",
    "end": "Không còn hoạt động cũ hơn.",
    "entries": "{{count}} mục",
    "types": {
      "new_merchant": "Merchant mới đăng ký",
      "large_order_500": "Đơn lớn (≥$500)",
      "sla_breach": "Vi phạm SLA",
      "sync_error": "Lỗi đồng bộ",
      "topup_approval": "Duyệt nạp tiền",
      "vendor_rating_change": "Thay đổi đánh giá vendor",
      "impersonation_event": "Sự kiện đóng vai"
    },
    "severity": {
      "info": "Thông tin",
      "warning": "Cảnh báo",
      "critical": "Nghiêm trọng"
    },
    "relative": {
      "justNow": "vừa xong",
      "minutes": "{{n}} phút trước",
      "hours": "{{n}} giờ trước",
      "days": "{{n}} ngày trước"
    }
  },
  "charts": {
    "gridAria": "Biểu đồ dashboard",
    "loadFailed": "Không tải được biểu đồ.",
    "revenue": {
      "title": "Xu hướng doanh thu",
      "subtitle": "Doanh thu theo ngày (USD chuẩn,)"
    },
    "orderVolume": {
      "title": "Số lượng đơn",
      "subtitle": "Số đơn theo ngày, xếp chồng theo trạng thái"
    },
    "utilization": {
      "title": "Tỉ lệ sử dụng vendor",
      "subtitle": "Top 10 vendor × 30 ngày"
    },
    "statusMix": {
      "title": "Cơ cấu trạng thái đơn",
      "subtitle": "Phân bố hiện tại theo trạng thái"
    },
    "topMerchants": {
      "title": "Top merchant theo GMV",
      "subtitle": "Bấm vào cột để mở trang merchant"
    },
    "simple": {
      "loading": "Đang tải dữ liệu…",
      "error": "Không tải được biểu đồ",
      "empty": "Chưa có dữ liệu trong khoảng thời gian này",
      "revenue": {
        "title": "Doanh thu",
        "subtitle": "USD theo ngày"
      },
      "orders": {
        "title": "Số lượng đơn",
        "subtitle": "Đơn hàng tạo theo ngày"
      },
      "utilization": {
        "title": "Tỉ lệ sử dụng năng lực vendor",
        "subtitle": "Trung bình utilization (%) theo ngày"
      },
      "status": {
        "title": "Phân bố trạng thái đơn",
        "subtitle": "Tổng đơn theo status"
      }
    }
  },
  "revenueChart": {
    "loadingAria": "Đang tải biểu đồ doanh thu",
    "figureAria": "Biểu đồ đường doanh thu, 30 ngày gần nhất, USD",
    "empty": "Không có dữ liệu doanh thu trong khoảng đã chọn."
  },
  "orderVolumeChart": {
    "loadingAria": "Đang tải biểu đồ số lượng đơn",
    "figureAria": "Biểu đồ số lượng đơn, số đơn theo ngày xếp chồng theo trạng thái",
    "empty": "Không có dữ liệu số lượng đơn trong khoảng đã chọn.",
    "series": {
      "pending": "Chờ xử lý",
      "in_progress": "Đang xử lý",
      "shipped": "Đã giao",
      "cancelled": "Đã hủy"
    }
  },
  "orderStatusChart": {
    "loadingAria": "Đang tải phân bố trạng thái đơn",
    "figureAria": "Biểu đồ tròn phân bố trạng thái đơn",
    "empty": "Không có dữ liệu trạng thái đơn.",
    "total": "Tổng"
  },
  "topMerchantsChart": {
    "loadingAria": "Đang tải biểu đồ top merchant theo GMV",
    "figureAria": "Biểu đồ cột ngang top merchant theo GMV",
    "empty": "Không có dữ liệu GMV merchant trong khoảng đã chọn."
  },
  "utilizationChart": {
    "loadingAria": "Đang tải heatmap sử dụng vendor",
    "figureAria": "Heatmap sử dụng vendor, top 10 vendor trong 30 ngày",
    "empty": "Không có dữ liệu sử dụng vendor trong khoảng đã chọn.",
    "day": "Ngày {{n}}"
  },
  "dateRange": {
    "presetsAria": "Bộ chọn khoảng thời gian",
    "from": "Từ",
    "to": "Đến",
    "apply": "Áp dụng",
    "presets": {
      "today": "Hôm nay",
      "last_7d": "7 ngày qua",
      "last_30d": "30 ngày qua",
      "this_month": "Tháng này",
      "last_month": "Tháng trước",
      "custom": "Tùy chỉnh"
    }
  },
  "vendorTable": {
    "heading": "Hiệu suất vendor",
    "tabsAria": "Tab hiệu suất vendor",
    "tabTop": "Vendor hàng đầu",
    "tabIssues": "Vendor có vấn đề",
    "loadError": "Không tải được hiệu suất vendor.",
    "emptyTop": "Chưa có vendor nào đạt ngưỡng hiệu suất.",
    "emptyIssues": "Hiện chưa có vendor nào bị gắn cờ vấn đề.",
    "columns": {
      "vendor": "Vendor",
      "rating": "Đánh giá",
      "orders": "Đơn hàng",
      "backOrderRate": "Tỉ lệ đặt thiếu",
      "utilization": "Tỉ lệ sử dụng",
      "atRiskFlags": "Cờ rủi ro",
      "actions": "Hành động"
    },
    "view": "Xem",
    "resolve": "Xử lý"
  },
  "widgetGrid": {
    "title": "Bảng điều khiển",
    "saving": "Đang lưu…",
    "addWidget": "+ Thêm widget",
    "resetDefault": "Đặt lại mặc định",
    "loadError": "Không tải được bố cục dashboard.",
    "rangeErrorCurrent": "Bố cục phải có {{min}}-{{max}} widget (hiện {{count}}).",
    "rangeError": "Bố cục phải có {{min}}-{{max}} widget.",
    "resetConfirmTitle": "Đặt lại dashboard về mặc định?",
    "resetConfirmDesc": "Sắp xếp widget tùy chỉnh của bạn sẽ được thay bằng bố cục mặc định cho vai trò của bạn. Không thể hoàn tác.",
    "resetConfirm": "Đặt lại",
    "cancel": "Hủy"
  },
  "widgetPicker": {
    "title": "Thêm hoặc bớt widget dashboard",
    "description": "Chọn từ {{min}} đến {{max}} widget. Bố cục được lưu tự động khi bạn bấm Áp dụng.",
    "empty": "Không có widget nào cho vai trò của bạn.",
    "tooFew": "Chọn ít nhất {{min}} widget (hiện {{count}}).",
    "tooMany": "Chọn tối đa {{max}} widget (hiện {{count}}).",
    "selected": "Đã chọn {{count}}/{{max}} widget.",
    "cancel": "Hủy",
    "apply": "Áp dụng",
    "categories": {
      "kpi": "KPI",
      "chart": "Biểu đồ",
      "table": "Bảng",
      "feed": "Dòng tin",
      "other": "Khác"
    }
  }
}
